module.exports = "//static.hsappstatic.net/ecosystem-marketplace-core/static-1.8028/img/diamond-tier-icon.svg"